/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'CportalModule';

export const albServiceConfigBreadcrumbTitle = `${prefix}.albServiceConfigBreadcrumbTitle`;

export const ENGLISH = {
    [albServiceConfigBreadcrumbTitle]: 'ALB Services Config',
};
